import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { TickValueComponent } from '../../tick-value/tick-value.component';
import { HotCompressAction } from 'src/app/types/sheet-action-aggregate-graph.types';

@Component({
    selector: 'app-hot-compress-slot',
    templateUrl: './hot-compress-slot.component.html',
    styleUrl: './hot-compress-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotCompressSlotComponent implements SheetSlotComponentBase {

	@Input() action!: HotCompressAction;
	value = null;

	constructor() {
	}
}
